"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloorPlan = void 0;
const Photo_1 = require("./Photo");
const CommonDto_1 = require("../dto/CommonDto");
class FloorPlan {
    constructor() {
        this.id = 0;
        this.title = "";
        this.photo = null;
        this.photoId = 0;
        this.order = 0;
    }
    static fromDto(eventFloorPlanDto) {
        const floorPlan = new FloorPlan();
        floorPlan.id = eventFloorPlanDto.id;
        floorPlan.title = eventFloorPlanDto.title;
        if (eventFloorPlanDto.photo && eventFloorPlanDto.photo.type === CommonDto_1.PhotoType.PHOTO) {
            floorPlan.photo = Photo_1.Photo.fromDto(eventFloorPlanDto.photo);
            floorPlan.photoId = floorPlan.photo.uploadId;
        }
        floorPlan.order = eventFloorPlanDto.order;
        return floorPlan;
    }
    toDto() {
        const resultDto = {
            id: this.id,
            title: this.title,
            order: this.order
        };
        if (this.photoId !== 0) {
            resultDto.photo = {
                type: CommonDto_1.PhotoType.ID,
                uploadId: this.photoId
            };
        }
        return resultDto;
    }
}
exports.FloorPlan = FloorPlan;
